/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import { Component } from '@angular/core';

/**
 * Generated class for the AwardIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'award-icon',
  templateUrl: 'award-icon.html'
})
export class AwardIconComponent {

  text: string;

  constructor() {
    console.log('Hello AwardIconComponent Component');
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/award-icon/award-icon.ts